/**
 * Filter for field naming.
 * 
 * @param {string} v - The value to filter.
 * @param {boolean} onlyLowerCase - Whether to only allow lowercase characters.
 * @param {number} maxLength - The maximum length of the value.
 * @param {boolean} allowSpacing - Whether to allow spacing.
 * @returns {string} - The filtered value.
 */
export const filterInputName = (v: string, onlyLowerCase: boolean, maxLength: number, allowSpacing: boolean): string => {
    let targetVal = v
    // Prevent special characters
    if (allowSpacing) {
        targetVal = targetVal.replace(/[^a-zA-Z0-9_ -]/g, ``)
        // Prevent multiple spaces
        targetVal = targetVal.replace(/\s\s+/g, ` `)
    } else {
        targetVal = targetVal.replace(/[^a-zA-Z0-9_-]/g, ``)
    }
    // Only allow lowercase characters
    if (onlyLowerCase) {
        targetVal = targetVal.toLowerCase()
    }
    // Prevent first character from being blank space or underscore
    if (targetVal.length === 1 && (targetVal === ` ` || targetVal === `_`)) {
        targetVal = ``
    }
    // Max length of maxLength characters
    targetVal = targetVal.substring(0, maxLength)
    return targetVal
}

